import UseAxios from '../../Api/http/http';
import { getKpi } from '../../Api/request/manageKpi';
import { STATUS_CODES } from '../../Api/resources/statusCodes';
import { NO_RECORDS_FOUND, OOPS_TRY_AGAIN } from '../../Constants/strings';

export const fetchKpiDetails = async (data) => {
  try {
    const response = await UseAxios(getKpi(data));

    if (response.data?.response?.status) {
      switch (response.data?.response?.status) {
      case STATUS_CODES.NO_DATA:
        return {
          noData: NO_RECORDS_FOUND,
        };
      case STATUS_CODES.INTERNAL_SERVER_ERROR:
      default:
        return {
          noData: OOPS_TRY_AGAIN,
        };
      }
    }
    if (response.data?.length === 0) {
      return {
        noData: NO_RECORDS_FOUND,
      };
    }
    return {
      status: STATUS_CODES.SUCCESS,
      data: {
        kpiDetails: response.data,
      },
    };
  } catch (error) {
    return {
      noData: OOPS_TRY_AGAIN,
    };
  }
};
